<template>
  <ModalBig :title="t('label_policy')" class="self-service-policy-modal" @close="closeModalPolicy">
    <div class="container-agreement-policy">
      <!--로고-->
      <div class="wrapper-title">
        <img :src="getAssetImageUrl('common/logos/logo-sconchat-full.png')" alt="Logo" class="logo" aria-label="Go home" />
      </div>
      <div class="wrapper-policy-description">
        <Tabs :tabs="tabs" :active-tab="indexTabActive" size="small" @tabClick="moveToPolicy" />
        <component :is="currentPolicyComponent" />
      </div>
    </div>
  </ModalBig>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
import PolicyPayment from '@/components/self-service/policy/PolicyPayment.vue';
import PolicyPrivacy from '@/components/self-service/policy/PolicyPrivacy.vue';
import PolicyService from '@/components/self-service/policy/PolicyService.vue';
import ModalBig from '@/components/shared/composite/ModalBig.vue';
import Tabs from '@/components/shared/composite/Tabs.vue';
import { useModalPolicy } from '@/composables/domains/self-service/useModalPolicy';

const { t } = useI18n();

const { policyCurrent, closeModalPolicy } = useModalPolicy();

const indexTabActive = ref(0); // 현재 바라보고 있는 탭

const SELF_SERVICE_POLICY_MAP = [
  {
    id: 'service',
    titleKey: 'policy_service',
    policyComponent: PolicyService,
  },
  {
    id: 'privacy',
    titleKey: 'policy_privacy',
    policyComponent: PolicyPrivacy,
  },
  {
    id: 'payment',
    titleKey: 'policy_payment',
    policyComponent: PolicyPayment,
  },
];

const tabs = computed<string[]>(() => {
  return SELF_SERVICE_POLICY_MAP.map(({ titleKey }) => titleKey);
});

const currentPolicyComponent = computed(() => {
  const { policyComponent } = SELF_SERVICE_POLICY_MAP[indexTabActive.value] || {};
  return policyComponent;
});

// 다른 탭으로 이동
const moveToPolicy = (inx: number) => {
  indexTabActive.value = inx;
};

// 처음 노출 시킬 탭 설정
const setInitialTab = () => {
  const indexTabToBe = SELF_SERVICE_POLICY_MAP.findIndex((item) => item.id === policyCurrent.value);

  moveToPolicy(indexTabToBe);
};

setInitialTab();
</script>

<style scoped>
.self-service-policy-modal {
  z-index: 1501;
}
.container-agreement-policy {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 50rem;
  gap: 1rem;
  margin: 0 auto 1rem auto;
}

.wrapper-title {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .logo {
    width: 10rem;
  }
}

.wrapper-policy-description {
  display: flex;
  flex-direction: column;
}
</style>
